export const getARImage = (imageUrl) => {
  if (imageUrl.startsWith('data:image/')) return imageUrl
  const [path, extension] = imageUrl.split('.')
  return `${path}%20ARA.${extension}`
}

export const resolveImageUrlForDeviceAndLocale = (
  imageUrl,
  locale,
  isDesktop,
  shouldSwitch,
) => {
  if (imageUrl) {
    if (typeof imageUrl === 'string') {
      return shouldSwitch && locale === 'ar' ? getARImage(imageUrl) : imageUrl
    }
    if (typeof imageUrl === 'object' && imageUrl.desktop && imageUrl.mobile) {
      if (isDesktop) {
        return shouldSwitch && locale === 'ar'
          ? getARImage(imageUrl.desktop)
          : imageUrl.desktop
      }
      return shouldSwitch && locale === 'ar'
        ? getARImage(imageUrl.mobile)
        : imageUrl.mobile
    }
  }
  return null
}
